export const slugGeneration = (title) =>
  title
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");

export const formatAndStorePermission = async () => {
  const userInfo = localStorage.getItem("user");
  if (userInfo) {
    const user = await JSON.parse(userInfo);
    let permissionLevel = user?.subAdmin?.level?.levelPermission;

    const outputObject = {};
    permissionLevel?.forEach((item) => {
      if (item.module && item.module.name) {
        const moduleName = item.module.name;
        const moduleData = {};

        if (item.read !== undefined) {
          moduleData.read = item.read;
        }
        if (item.write !== undefined) {
          moduleData.write = item.write;
        }

        outputObject[moduleName] = moduleData;
      }
    });

    localStorage.setItem("level", JSON.stringify(outputObject));
  }
};

export function commaSeparated(num) {
  console.log("calling a function -->  comma ");
  return num.toLocaleString("en-US");
}
